export enum AccessStatusIdEnum {
    Enabled = 1,
    DisabledNonPayment = 2,
    DisabledOther = 3,
}
